import Button, { type ButtonProps } from '@discover-ui/button';
import Skeleton from '@discover-ui/skeleton';

export type SelectSkeletonProps = ButtonProps;

export default function SelectSkeleton(props: SelectSkeletonProps) {
  return <Skeleton as={Button} className="w-[180px] border border-input" {...props} />;
}
